import { Component, CUSTOM_ELEMENTS_SCHEMA, input, InputSignal } from '@angular/core';

@Component({
    selector: 'sh-radio-card-item',
    standalone: true,
    templateUrl: './sh-radio-card-item.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ShRadioCardItemComponent {
    public value: InputSignal<string> = input.required<string>();

    public selected = false;
    public dimmed = false;

    /** Called by parent ShRadioCardComponent */
    public onSelect: () => void = () => {};
}
